import React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BTable from 'react-bootstrap/Table';
import { ToastService } from "../../../services/toast.service";
import { HeaderList } from "../../../components/HeaderList";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { LocaleService } from "../../../services/locale.service";
import { LocaleModel } from "../../../models/locale.model";

import { FuncaoModel } from "../../../models/funcao.model";
import { TipoGraficoModel } from "../../../models/tipoGrafico.model";

import TransporterService from "../../../services/transporter.service";
import { TransporterModel } from "../../../models/transporter.model";

import { BranchService } from "../../../services/branch.service";
import { BranchModel } from "../../../models/branch.model";

import PredictionModelService from "../../../services/predictionModel.service";
import { PredictionModelModel } from "../../../models/predictionModel.model";

import { EquipmentModel } from "../../../models/equipment.model";
import { EquipmentService } from "../../../services/equipment.service";

import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";

import { HeadDateModel } from "../../../models/headDate.model";

// import UtilService from "../../../services/util.service";
// import data from "./data.js";

import { EventExportService } from "../../../services/eventExport.service";
import { ForeCastService } from "../../../services/forecast.service";
import moment from 'moment';
import storageService from "../../../services/storage.service";
import UtilService from "../../../services/util.service";
import { useTable, usePagination, useSortBy } from 'react-table';
import InfiniteScroll from "react-infinite-scroll-component";
import { faSortAlphaUp, faSortAlphaDown, faSort, faCalendarCheck, faExclamationTriangle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import HelperService from "../../../services/helper.service";
import { Chart } from "react-google-charts";
import DatePicker from "react-datepicker";
import { ButtonClean, ButtonSearch, ButtonExport } from "../../../components/buttons";
import CustomRangeDatePicker from "../../../components/CustomDatePickerRange";


function Table({ columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];

  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    allColumns,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        //pageIndex: 0,
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style = {
      border: 'none',
      background: cellInfo.background,
      color: 'white',
      fontWeight: 600,
      textAlign: 'center'
    };
    return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style = {
      width: '100%',
      height: '100%',
      padding: 2
    };

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <>
      <InfiniteScroll
        dataLength={rows.length}
        next={update}
        hasMore={rows.length !== (total_records || 0)}
        loader={<strong>...</strong>}
      // style={{ overflowX: "hidden" }}
      >
        <BTable bordered hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={formatCellStyleHeader(column)}
                  >
                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                      <div style={{ display: "table-caption" }}>
                        {column.render('Header')}
                      </div>
                      {column.canSort
                        ? column.isSorted
                          ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                          : <FontAwesomeIcon icon={faSort} />
                        : null
                      }
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row)
              const isUpdated = row.original.isUpdated;
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {

                    if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                      return <td
                        colSpan={7}
                        {...cell.getCellProps()}
                        style={{
                          background: "#fff",
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          color: '#555',
                          padding: 0,
                          opacity: isUpdated ? 1 : 0.65
                        }}
                      >
                        <div style={formatCellStyle(cell)}>
                          {msgEmpty}
                        </div>
                      </td>
                    }

                    if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                      return <></>;
                    }
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          background: "#fff",
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          color: '#555',
                          padding: 0,
                          opacity: isUpdated ? 1 : 0.65
                        }}
                      >
                        <div style={formatCellStyle(cell)}>
                          {cell.render('Cell')}
                        </div>
                      </td>
                    )
                  }
                  )}
                </tr>
              )
            })}
          </tbody>
        </BTable>
      </InfiniteScroll>
    </>
  );
}

const DepositList = () => {
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const user = storageService.getUser();

  const [headDate, setHeadDate] = useState<HeadDateModel>();
  const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
  const [startDate, setStartDate] = useState<Date | null>(new Date(new Date().setDate(new Date().getDate() - 15)));
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [dateRangeChart, setDateRangeChart] = useState<any>();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'deposit',
    filters: {
      transporter_id: [],
      branch_id: [],
      //prediction_model_id: [], Removendo o prediciton model id
      locale_id: [],
      equipment_id: [],
      tipoGrafico_id: [],
      //funcao_id: [], Removendo a funcao id
    },
    sort: {
      field: 'codeEquipment',
      orientation: 'asc'
    },
    parameters: {
      filter_monetary_physical: [0],
    }
  });

  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [locales, setLocales] = useState<LocaleModel[]>();
  const [funcao, setFuncao] = useState<FuncaoModel[]>();
  const [tipoGrafico, setTipoGrafico] = useState<TipoGraficoModel[]>();

  const [branches, setBranches] = useState<BranchModel[]>();
  const [predictionModels, setPredictionModels] = useState<PredictionModelModel[]>();
  const [equipments, setEquipments] = useState<EquipmentModel[]>();

  const [showEquipmentsPickupInPeriod, setShowEquipmentsPickupInPeriod] = useState<boolean>(false);
  const [showEquipmentsEventsInPeriod, setShowEquipmentsEventsInPeriod] = useState<boolean>(false);
  const [addressClassifiedAsRisk, setAddressClassifiedAsRisk] = useState<boolean>(false);

  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'dashboard_analytical',
    filters: {
      locale_id: [],
      transporter_id: [],
      branch_id: [],
      tipoGrafico_id: [],
      //funcao_id: [],
      is_pickup: null,
      is_event: null,
      is_danger: null
    },
    pagination: {
      page_number: 1,
      total_pages: 1,
      records_pages: 100,
      total_records: 0
    },
  });

  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]);
  const [dataChart, setDataChart] = useState<any>();


  const columnsPT = React.useMemo(
    () => [
      {
        Header: "Equipamento",
        background: '#4b4b50',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.READ_DATE")}</span>),
            accessor: "read_date",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (formatDateTime(props.value))
          }
        ]
      },
      {
        Header: "Depósitos",
        background: '#0000FF',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_VALUE")}</span>),
            accessor: "deposit_value",
            background: '#6495ED',
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_VALUE_CALCULATION")}</span>),
            background: '#6495ED',
            accessor: "deposit_value_calculation",
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_VALUE_DIFERENCE")}</span>),
            background: '#6495ED',
            accessor: "deposit_value_diference",
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_PERCENT_DIFERENCE")}</span>),
            background: '#6495ED',
            disableSortBy: true,
            accessor: "deposit_percent_diference",
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_deposit, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }, {
        Header: "Saldo",
        background: '#008000',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE")}</span>),
            accessor: "balance_value",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE_CALCULATION")}</span>),
            accessor: "balance_value_calculation",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE_DIFERENCE")}</span>),
            accessor: "balance_value_diference",
            disableSortBy: true,
            background: '#2E8B57',
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_PERCENT_DIFERENCE")}</span>),
            background: '#2E8B57',
            accessor: "balance_percent_diference",
            disableSortBy: true,
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_balance, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }, {
        Header: "Coleta",
        background: '#DAA520',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_VALUE")}</span>),
            accessor: "pickup_value",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_VALUE_CALCULATION")}</span>),
            accessor: "pickup_value_calculation",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_VALUE_DIFERENCE")}</span>),
            accessor: "pickup_value_diference",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: props => (dataset?.parameters.filter_monetary_physical == 0) ? (formatToCurrency(props.value)) : props.value
          },
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_PERCENT_DIFERENCE")}</span>),
            accessor: "pickup_percent_diference",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_pickup, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }
    ],
    [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]
  );



  const columnsUS = React.useMemo(
    () => [
      {
        Header: t("TYPE_CHART.EQUIPMENT"),
        background: '#4b4b50',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.READ_DATE")}</span>),
            accessor: "read_date",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (formatDateTime(props.value))
          }
        ]
      },
      {
        Header: t("TYPE_CHART.DEPOSIT"),
        background: '#0000FF',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_VALUE")}</span>),
            accessor: "deposit_value",
            background: '#6495ED',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_VALUE_CALCULATION")}</span>),
            background: '#6495ED',
            accessor: "deposit_value_calculation",
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_VALUE_DIFERENCE")}</span>),
            background: '#6495ED',
            accessor: "deposit_value_diference",
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.DEPOSIT_PERCENT_DIFERENCE")}</span>),
            background: '#6495ED',
            disableSortBy: true,
            accessor: "deposit_percent_diference",
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_deposit, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }, {
        Header: t("TYPE_CHART.BALANCE"),
        background: '#008000',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE")}</span>),
            accessor: "balance_value",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE_CALCULATION")}</span>),
            accessor: "balance_value_calculation",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_VALUE_DIFERENCE")}</span>),
            accessor: "balance_value_diference",
            disableSortBy: true,
            background: '#2E8B57',
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.BALANCE_PERCENT_DIFERENCE")}</span>),
            background: '#2E8B57',
            accessor: "balance_percent_diference",
            disableSortBy: true,
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_balance, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }, {
        Header: t("TYPE_CHART.COLLECT"),
        background: '#DAA520',
        columns: [
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_VALUE")}</span>),
            accessor: "pickup_value",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_VALUE_CALCULATION")}</span>),
            accessor: "pickup_value_calculation",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_VALUE_DIFERENCE")}</span>),
            accessor: "pickup_value_diference",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          },
          {
            Header: props => (<span>{t("DEPOSIT.PICKUP_PERCENT_DIFERENCE")}</span>),
            accessor: "pickup_percent_diference",
            background: '#d6b35a',
            disableSortBy: true,
            Cell: (props) => {
              return <>
                <div style={{
                  backgroundColor: props.row.original.color_pickup, color: 'black',
                  fontWeight: 'bold'
                }}>
                  {formatToCurrency(props.value)}
                </div>
              </>
            }
          },
        ]
      }
    ],
    [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]
  );


  const [optionsChart, setOptionsChart] = useState<any>();
  const idiom = storageService.getIdiom();
  const formatDateTime = (value) => {
    return UtilService.formatDate(value, user.locale.formatDate);
  };

  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  function getFunctions(): Array<FuncaoModel> {
    var funcao: FuncaoModel[] = null;

    funcao = [
      {
        id: 1,
        name: t('SUM')
      },
      {
        id: 2,
        name: t('AVERAGE')
      },

    ]

    return funcao;
  }

  function getTipoGrafico(): Array<TipoGraficoModel> {
    var item: TipoGraficoModel[] = null;

    item = [
      {
        id: 1,
        name: t('TYPE_CHART.DEPOSIT')
      },
      {
        id: 2,
        name: t('TYPE_CHART.BALANCE')
      },
      {
        id: 3,
        name: t('TYPE_CHART.COLLECT')
      },

    ]

    return item;
  }

  const initialize = async () => {

    LocaleService.getAll().then((response: any) => {
      setLocales(response.result);
    });

    const sort = (getFunctions() ?? []).sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    setFuncao(sort);

    const sortGrafico = (getTipoGrafico() ?? []).sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    setTipoGrafico(sortGrafico);

    TransporterService.getAllList().then((response: any) => {
      if (response.success) {
        let transporterList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'transporter' });
        const sort = (transporterList?.[0]?.data ?? []).sort(
          (a, b) => a.fullName.localeCompare(b.fullName)
        );
        setTransporters(sort);
      } else {
        setTransporters([]);
      }
    });

    /* BranchService.getAllList().then((response: any) => {
      if(response.success){
        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
        const sort = branchList[0].data.sort((a, b) => a.fullName.localeCompare(b.fullName))
        setBranches(sort);
      }else{
        setBranches([]);
      }
    }); */

    /* PredictionModelService.getAll().then((response: any) => {
      setPredictionModels(response.result);
      if (response.result.length === 1) {
        setDataset({ ...dataset, filters: { ...dataset.filters, prediction_model_id: [Number(response.result[0].id)] } })
        setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, prediction_model_id: [Number(response.result[0].id)] } })
      }
    }) */

    EquipmentService.getAllList().then((response: any) => {
      if (response.success) {
        let equipmentList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'equipment' });
        const sort = (equipmentList?.[0]?.data ?? []).sort(
          (a, b) => a.codeEquipment.localeCompare(b.codeEquipment)
        );
        setEquipments(sort);
      } else {
        setEquipments([]);
      }
    });

  };

  const exportFile = async () => {
    /* if (dataset?.filters?.prediction_model_id[0] == undefined) {
      ToastService.warn(t('MODEL.ALERT_MODEL'), null);
      return;
    }

    if (dataset?.filters?.funcao_id[0] == undefined) {
      ToastService.warn(t('MODEL.ALERT_FUNCTION'), null);
      return;
    } */

    if (dataset?.filters?.tipoGrafico_id[0] == undefined) {
      ToastService.warn(t('MODEL.ALERT_CHART'), null);
      return;
    }

    // event.preventDefault();
    getListExport(null);
  };

  const getListExport = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    requestParams.parameters = {
      ...requestParams.parameters,
      date_begin: moment(startDate),
      date_end: endDate,
      group_format: 1,
      filter_monetary_physical: dataset.parameters.filter_monetary_physical[0]
    }

    EventExportService.Export(requestParams).finally(() => {
      setLoading(false);
    });
  };


  const getList = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    requestParams.parameters = {
      ...requestParams.parameters,
      date_begin: moment(startDate),
      date_end: endDate,
      group_format: 1,
      filter_monetary_physical: dataset.parameters.filter_monetary_physical[0]
    }

    const response: any = await ForeCastService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'dashboard_analytical' }));
      setDatasetDashboardAnalytical(d);
      let dChart = [];
      dChart.push(['', t('REAL'), t('CALCULATION'), t('DIFERENCE')]);
      if (d.data) {
        d.data.map((data) => {
          switch (requestParams.datasets[0].filters.tipoGrafico_id[0]) {
            case 1:
              dChart.push([UtilService.formatDate(data.read_date, user.locale.formatDate), data.deposit_value, data.deposit_value_calculation, data.deposit_value_diference]);
              setOptionsChart({
                chart: {
                  title: t("CHART.TITLE_LIST_DEPOSIT")
                },
                colors: ['#0000FF', '#6495ED', '#93aad4'],
                seriesType: 'bars',
              });
              break;
            case 2:
              dChart.push([UtilService.formatDate(data.read_date, user.locale.formatDate), data.balance_value, data.balance_value_calculation, data.balance_value_diference]);
              setOptionsChart({
                chart: {
                  title: t("CHART.TITLE_LIST_BALANCE")
                },
                colors: ['#0000FF', '#6495ED', '#93aad4'],
                seriesType: 'bars',
              });
              break;
            case 3:
              dChart.push([UtilService.formatDate(data.read_date, user.locale.formatDate), data.pickup_value, data.pickup_value_calculation, data.pickup_value_diference]);
              setOptionsChart({
                chart: {
                  title: t("CHART.TITLE_LIST_COCKPIT")
                },
                colors: ['#0000FF', '#6495ED', '#93aad4'],
                seriesType: 'bars',
              });
              break;
          }
        });

        if (dChart.length > 1) {

          let eDate = moment(dChart[1][0], "DD/MM/YYYY", true);
          let sDate = moment(dChart[1][0], "DD/MM/YYYY", true).subtract(15, 'days');

          setDateRangeChart({
            endDate: eDate,
            startDate: sDate
          });
        }


        setDataChart(dChart);
      } else {
        setDataChart(null);
      }
    }
    else {
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
    }

    setLoading(false);
  };


  const handleSearch = async (event) => {

    /*  if (dataset?.filters?.prediction_model_id[0] == undefined) {
       ToastService.warn(t('MODEL.ALERT_MODEL'), null);
       return;
     }
 
     if (dataset?.filters?.funcao_id[0] == undefined) {
       ToastService.warn(t('MODEL.ALERT_FUNCTION'), null);
       return;
     } */

    if (dataset?.filters?.tipoGrafico_id[0] == undefined) {
      ToastService.warn(t('MODEL.ALERT_CHART'), null);
      return;
    }

    event.preventDefault();
    await getList(null);
  };

  const handleClean = (event) => {
    event.preventDefault();
    setDataset({
      ...dataset, filters: {
        transporter_id: [],
        branch_id: [],
        //prediction_model_id: [],
        locale_id: [],
        equipment_id: [],
        tipoGrafico_id: [],
        //funcao_id: [],
      },
      parameters: {
        filter_monetary_physical: [0],
      }
    });
    // Limpa estado visual
    setBranches([]);         // 👈 limpa a lista de branches para não manter visuais anteriores
    setEquipments([]);       // 👈 se quiser também zerar os equipamentos

    // Recarrega todos os equipamentos após limpar
    EquipmentService.getAllList().then((response: any) => {
      if (response.success) {
        let equipmentList = response.result.datasets.filter((d) => d.dataset === 'equipment');
        const sort = Array.isArray(equipmentList?.[0]?.data)
        ? equipmentList[0].data.sort((a, b) => (a?.codeEquipment || "").localeCompare(b?.codeEquipment || ""))
        : [];
        setEquipments(sort);
      } else {
        setEquipments([]);
      }
    });
    clearData();
  };

  const clearData = () => {
    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    setDataChart(null);
    requestParams.datasets[0].data = null;
    setDatasetDashboardAnalytical(requestParams.datasets[0]);
  }

  const addDayToPeriod = async (value) => {
    if (!dateRangeChart || !dateRangeChart.startDate || !dateRangeChart.endDate) {
      console.warn("dateRangeChart ou datas estão indefinidas");
      return;
    }
  
    const rDate = {
      startDate: moment(dateRangeChart.startDate).add(value, 'days'),
      endDate: moment(dateRangeChart.endDate).add(value, 'days')
    };
  
    setDateRangeChart(rDate);
  };
  

  const renderPeriodDescription = (value) => {
    if (value) {
       return(
             <>
             {dateRangeChart?.startDate
               ? UtilService.formatDate(dateRangeChart.startDate, user.locale.formatDate)
               : ''}
             </>      
        )
    }
    else {
      return(
        <>
        {dateRangeChart?.endDate
          ? UtilService.formatDate(dateRangeChart.endDate, user.locale.formatDate)
          : ''}
        </>      
      )
    }
  }

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderList title={t(`MENU_FORECAST_ANALYSIS`) + " / " + t(`DEPOSIT.TITLE_LIST`)} />
      <Form>
        <Form.Label className="mb-0">{t("FILTERS")}</Form.Label>
        <Row className="align-items-center">

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.transporter_id.length > 0 ? dataset.filters.transporter_id[0] : ''}
                  onChange={(e) => {
                    const selectedId = Number(e.target.value);

                    const updatedFilters = {
                      ...dataset.filters,
                      transporter_id: selectedId ? [selectedId] : [],
                      branch_id: [],
                      equipment_id: []
                    };

                    setDataset({ ...dataset, filters: updatedFilters });
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: updatedFilters });

                    setBranches([]);
                    setEquipments([]);

                    // ⚠️ Aqui você SEMPRE carrega todos os equipamentos da transportadora
                    EquipmentService.getAllList().then((response: any) => {
                      if (response.success) {
                        const equipmentList = response.result.datasets.find((d) => d.dataset === 'equipment');
                        const sorted = (equipmentList?.data ?? []).sort(
                          (a, b) => a.codeEquipment.localeCompare(b.codeEquipment)
                        );
                        setEquipments(sorted);
                      } else {
                        setEquipments([]);
                      }
                    });

                    if (!selectedId) return; // se não selecionou nenhuma, não precisa buscar branches

                    const datasetFiltered: DatasetModel = {
                      ...JSON.parse(JSON.stringify(DatasetDefault)),
                      dataset: 'branch',
                      filters: {
                        fullname: [],
                        nickname: [],
                        document: [],
                        transporter_id: [selectedId]
                      },
                      sort: {
                        field: 'fullName',
                        orientation: 'asc'
                      },
                      pagination: {
                        page_number: 1,
                        total_pages: 9999,
                        records_pages: 9999,
                        total_records: 0
                      }
                    };

                    BranchService.getList({ ...RequestInputOutputParamsModelDefault, datasets: [datasetFiltered] })
                      .then((response: any) => {
                        if (response.success) {
                          const branchList = response.result.datasets.find((d) => d.dataset === "branch");
                          const sort = (branchList?.data ?? []).sort(
                            (a, b) => a.fullName.localeCompare(b.fullName)
                          );
                          setBranches(sort);
                        } else {
                          setBranches([]);
                        }
                      });
                  }}
                >
                  <option value=''>{t("EQUIPMENT.TRANSPORTERNAME")}</option>
                  {_.map(transporters, (l: TransporterModel) => (
                    <option key={l.id} value={l.id}>{l.fullName}</option>
                  ))}
                </Form.Control>
                <label htmlFor="status">{t("EQUIPMENT.TRANSPORTERNAME")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.branch_id.length > 0 ? dataset?.filters?.branch_id[0] : ''}
                  onChange={(e) => {
                    const branchId = Number(e.target.value);

                    const updatedFilters = {
                      ...dataset.filters,
                      branch_id: branchId ? [branchId] : [],
                      equipment_id: []
                    };

                    setDataset({ ...dataset, filters: updatedFilters });
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: updatedFilters });
                    setEquipments([]); // sempre limpa antes

                    // Se não tiver branch selecionada, busca todos os equipamentos
                    if (!branchId) {
                      EquipmentService.getAllList().then((response: any) => {
                        if (response.success) {
                          const equipmentList = response.result.datasets.find((d) => d.dataset === "equipment");
                          const sortedEquipments = equipmentList?.data?.sort((a, b) => a.codeEquipment.localeCompare(b.codeEquipment)) || [];
                          setEquipments(sortedEquipments);
                        } else {
                          setEquipments([]);
                        }
                      });
                      return;
                    }

                    // Buscar equipamentos da branch
                    const datasetFiltered: DatasetModel = {
                      ...JSON.parse(JSON.stringify(DatasetDefault)),
                      dataset: 'equipment',
                      filters: {
                        code_equipment: [],
                        branch_id: [branchId]
                      },
                      sort: {
                        field: 'code_equipment',
                        orientation: 'asc'
                      },
                      pagination: {
                        page_number: 1,
                        total_pages: 9999,
                        records_pages: 9999,
                        total_records: 0
                      }
                    };

                    EquipmentService.getList({ ...RequestInputOutputParamsModelDefault, datasets: [datasetFiltered] })
                      .then((response: any) => {
                        if (response.success) {
                          const equipmentList = response.result.datasets.find((d) => d.dataset === "equipment");
                          const sortedEquipments = equipmentList?.data?.sort((a, b) => a.codeEquipment.localeCompare(b.codeEquipment)) || [];
                          setEquipments(sortedEquipments);
                        } else {
                          setEquipments([]);
                        }
                      });
                  }}
                >
                  <option value=''>{t("FILTER.SELECT")}</option>
                  {_.map(branches, (item: BranchModel) => (
                    <option key={item.id} value={item.id}>{item.fullName}</option>
                  ))}
                </Form.Control>
                <label>{t("FILTER.BRANCH")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.equipment_id.length > 0 ? dataset?.filters?.equipment_id[0] : ''}
                  onChange={(e) => {
                    if (e.target.value === '') {
                      setDataset({ ...dataset, filters: { ...dataset.filters, equipment_id: [] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, predictiequipment_idonModel_id: [] } })
                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, equipment_id: [Number(e.target.value)] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, equipment_id: [Number(e.target.value)] } })
                    }
                  }}
                >
                  <option value='0'>{t("FILTER.SELECT")}</option>
                  {_.map(equipments, (item: EquipmentModel) => {
                    return <option key={item.id} value={item.id}>{item.codeEquipment}</option>
                  })}
                </Form.Control>
                <label>{t("FILTER.EQUIPMENT")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.tipoGrafico_id.length > 0 ? dataset.filters.tipoGrafico_id[0] : ''}
                  onChange={(e) => {
                    if (e.target.value === '') {
                      setDataset({ ...dataset, filters: { ...dataset.filters, tipoGrafico_id: [] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, tipoGrafico_id: [] } })

                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, tipoGrafico_id: [Number(e.target.value)] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, tipoGrafico_id: [Number(e.target.value)] } })
                    }
                  }}
                >
                  <option value=''>{t("FILTER.SELECT")}</option>
                  {_.map(tipoGrafico, (l: TipoGraficoModel) => {
                    return <option key={l.id} value={l.id}>{l.name}</option>
                  })}
                </Form.Control>
                <label>{t("FILTER.TYPE_CHART")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.parameters?.filter_monetary_physical.length > 0 ? dataset.parameters.filter_monetary_physical[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, parameters: { ...dataset.parameters, filter_monetary_physical: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, parameters: { ...datasetDashboardAnalytical.parameters, filter_monetary_physical: [Number(e.target.value)] } })
                  }}
                >
                  <option value='0'>{t("DEPOSIT.MONETARY")}</option>
                  <option value='1'>{t("DEPOSIT.PHYSIC")}</option>
                </Form.Control>
                <label htmlFor="status">{t("DEPOSIT.REPORT_TYPE")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={2}>
            <CustomRangeDatePicker
              startDate={startDate}
              endDate={endDate}
              onChange={(dates) => {
                const [start, end] = dates;
                setStartDate(start);
                setEndDate(end);
              }}
              label={t("CHART.DATA_RANGE")} // ou o label que desejar
              disabled={isLoading}    // se necessário
            />
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col xs="auto">
            <ButtonSearch onClick={(e) => handleSearch(e)} isLoading={isLoading} />
          </Col>

          <Col xs="auto">
            <ButtonClean onClick={async (e) => handleClean(e)} isLoading={isLoading} />
          </Col>

          <Col xs="auto">

            <ButtonExport onClick={() => exportFile()} isLoading={isLoading} />

          </Col>
        </Row>

      </Form>

      <Row className="align-items-center pt-3">
        <Col sm={12}>
          <Button
            className="me-2"
            onClick={() => { addDayToPeriod(-1) }}>{' < '}</Button>

          <Button className="me-2"
            onClick={() => { addDayToPeriod(1) }}>{' > '}</Button>
          <Form.Label> {renderPeriodDescription(true)} - {renderPeriodDescription(false)}</Form.Label>
        </Col>
      </Row>
      <Row className="align-items-center pb-3 pt-3">
        <>
          {dataChart &&

            <Col xs={12} sm={12} md={12} lg={12}>
              <Chart
                chartType="Bar"
                width="100%"
                height="400px"
                data={_.filter(dataChart, (c, index) => {
                   if (Number(index) === 0) return true;
                   return moment(c[0], 'DD/MM/YYYY') >= dateRangeChart.startDate && moment(c[0], 'DD/MM/YYYY') <= dateRangeChart.endDate;
                })}
                options={optionsChart}
              />
            </Col>}
        </>
      </Row>

      <Row className="align-items-center pb-3">
        <Col sm={12}>
          <Table
            data={data}
            columns={idiom == "pt-BR" ? columnsPT : columnsUS}
            update={null}
            total_records={datasetDashboardAnalytical?.pagination?.total_records}
            msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} />
        </Col>
      </Row>
    </>
  );
};

export default DepositList;
